import { CircleHelp } from 'lucide-react';
import { type ReactElement, useCallback, useState } from 'react';
import { EditorDialog } from './editor-dialog';

const TIPS: readonly { readonly title: string; readonly body: string }[] = [
  {
    title: '이미지·텍스트 넣기',
    body: '스테이지의 [이미지 업로드]·[텍스트] 칸에서 이미지를 올리거나 텍스트를 추가하세요. 지금 보고 있는 면의 인쇄 영역 가운데에 놓입니다.',
  },
  {
    title: '상품 위에서 바로 편집',
    body: '상품 사진 위의 디자인을 눌러 고르고 그 자리에서 바로 옮기고 고칩니다. 디자인을 고르면 인쇄 영역 테두리가 진하게 보입니다. 머그·텀블러 같은 곡면 상품은 끄는 동안 평면으로 보이다가, 손을 떼면 상품 곡면에 맞춰 휘어져 보입니다.',
  },
  {
    title: '옮기기·크기·회전',
    body: '레이어를 끌어 옮기고, 모서리 핸들로 크기를, 위쪽 핸들로 회전을 바꿉니다(Shift 를 누르면 15° 단위). 텍스트는 좌우 핸들로 줄 폭을 바꿉니다.',
  },
  {
    title: '도구 막대',
    body: '스테이지 위쪽 도구 줄로 레이어를 앞·뒤로 옮기고, 인쇄 영역 왼쪽·가운데·오른쪽·위·아래에 맞추고, 이미지를 좌우·상하로 뒤집을 수 있습니다.',
  },
  {
    title: '키보드',
    body: '화살표 키로 1mm(Shift 10mm)씩 옮기고 Delete 로 지웁니다. ⌘/Ctrl+Z 로 취소, ⌘/Ctrl+Shift+Z 로 다시 실행합니다.',
  },
  {
    title: '이미지 파일',
    body: 'PNG·JPG·WebP, 10MB 이하를 올릴 수 있습니다. 인쇄 영역을 벗어난 부분은 인쇄되지 않습니다.',
  },
];

/** 면 탭 줄 오른쪽의 작은 글자 링크 — 누르면 에디터 사용 안내를 대화상자로 보여 준다. */
export const DesignGuideButton = (): ReactElement => {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  return (
    <>
      <button
        type="button"
        aria-haspopup="dialog"
        className="inline-flex h-12 shrink-0 cursor-pointer items-center gap-1.5 text-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        onClick={() => setOpen(true)}
      >
        <CircleHelp aria-hidden className="size-4" strokeWidth={1.5} />
        디자인하는 방법
      </button>
      <EditorDialog open={open} title="디자인하는 방법" onClose={close}>
        <ol className="divide-y divide-foreground/10">
          {TIPS.map((tip, index) => (
            <li key={tip.title} className="flex gap-4 py-3.5 first:pt-0 last:pb-0">
              <span className="w-6 shrink-0 pt-px text-xs font-semibold text-muted-foreground tabular-nums">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div>
                <p className="font-semibold">{tip.title}</p>
                <p className="mt-0.5 leading-relaxed text-muted-foreground">{tip.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </EditorDialog>
    </>
  );
};
